module.exports = {
  selectLanguage: "Change language",
  aboutp1:
    "In Ewwo Consulting we offer integral solutions in regards to information technology issues.",
  aboutp2:
    "Our team has a vast experience in the field with different customer with various needs, all of which have accomplished customer satisfaction.",
  aboutp3:
    "This allows us to offer specific solutions for every need, whichever the nature, size or complexity of the problem is.",
  aboutp4:
    "Our expertise entitles us to offer you a quick response shaped to our customers’ needs and a remarkable organization which holds specific knowledge and technological aptitude.",
  aboutp5:
    "It's our responsibility the follow up and assistance on the product made based in our customers' requirements.",
  aboutp6:
    "We focus on giving the best possible service before, during and after the development of the agreed product. We devote ourselves 100% on, once the product is made, accompanying and assisting our customers with constant training.",
  consultingp1:
    "In Ewwo, we use strategy consulting services to help executives enhance short -and long- term shareholder value by identifying areas to improve the business through planning, growth and operational solutions.",
  consultingp2:
    "Talent and organization services help companies increase their productivity, market share and shareholder value by ensuring they have the right people with the right skills in the right roles.",
  consultingp3:
    "Also, we must point out that our capabilities range are from accessing and reporting on data to predictive modeling, forecasting and sophisticated statistical analysis.",
  consultingp4:
    "We have a specially flexible work dynamic, which is a necessary and fundamental skill for rapid adaptation and quick response.",
  servicestxt:
    "For more than 7 years we have ben providing services and solutions for HMOs. We have 3 main products to manage everything in relation to affiliates, affiliations and HMO revenues, amongst other things.",
  outsourcingtxt1p1:
    "Business process outsourcing services involve the contracting of the operations and responsibilities of specific business functions (or processes) to a third-party service provider.",
  outsourcingtxt1p2:
    "This tool is not only a way to reduce costs, but also to gain access to industry-leading practices and scarce skills and to embed innovation into their organizations.",
  outsourcingtxt1p3:
    "We pay attention to details and use mechanisms to improve efficiency and performance, reducing costs and making easy to our customers to focus on their business.",
  outsourcingtxt2:
    "In EWWO, we understand that a successful outsourcing relationships needs to be flexible in order to meet both short -and long- term goals. Also, we guarantee that our methodologies, expertise and global reach will ensure that your organization’s goals are met.",
  footermsg:
    "If you wish to contact us, you may use one of the following alternatives:",
  copyright: "All rights reserved.",
  design: "Design: "
};



// WEBPACK FOOTER //
// ./src/data/messages/en.js